import Axios, { AxiosRequestConfig } from "axios";

import { API_PATIENT_ENDPOINT } from "../util/env";

export const PATIENT_API_AXIOS_INSTANCE = Axios.create({
  baseURL: API_PATIENT_ENDPOINT,
});

const ID_TOKEN_KEY = "idToken";

export const useAPIPatientClient = <T>(): ((
  config: AxiosRequestConfig
) => Promise<T>) => {
  return (config: AxiosRequestConfig & { tag?: string }) => {
    const token = localStorage.getItem(ID_TOKEN_KEY);
    const source = Axios.CancelToken.source();

    const promise = PATIENT_API_AXIOS_INSTANCE({
      ...config,
      cancelToken: source.token,
      headers: { Authorization: `Bearer ${token}` },
    }).then(({ data }) => data);

    // @ts-ignore
    promise.cancel = () => {
      source.cancel("Query was cancelled by React Query");
    };
    return promise;
  };
};

export default useAPIPatientClient;

export type ErrorType<ErrorData> = ErrorData;

export type BodyType<BodyData> = BodyData & { headers?: any };
